import { GlobalStateProvider } from "./GlobalStateProvider";
import StepControlWrapper from "./StepControlWrapper";
import "./App.css";

function App() {
  return (
    <GlobalStateProvider>
      <StepControlWrapper></StepControlWrapper>
    </GlobalStateProvider>
  );
}

export default App;
